import { computeAnalyticsEcommerceItemsTotalValue, convertProductToAnalyticsEcommerceItem } from './analyticsProduct';
import { EcommerceEvent, pushGTMEcommerceEvent } from '@helpers/analyticsHelpers/pushGTMEvent';
import type { AxfoodOfflineProductViewModel, AxfoodProductDetailsViewModel } from '@occ/api-client';

const trackProductDetail = (
  product: AxfoodProductDetailsViewModel | AxfoodOfflineProductViewModel,
  isLoggedIn?: boolean
) => {
  const items = [convertProductToAnalyticsEcommerceItem(product, false, undefined, isLoggedIn)];
  pushGTMEcommerceEvent({
    event: EcommerceEvent.VIEW_ITEM,
    ecommerce: {
      currency: 'SEK',
      value: computeAnalyticsEcommerceItemsTotalValue(items),
      items,
    },
  });
};

export default trackProductDetail;
